import React from "react";
import './contact_section.css'

// reactstrap components
import {
    Button,
    CardImg,
    CardText,
    CardSubtitle,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Input,
    Container,
    Col,
    Row
} from "reactstrap";

class Contact extends React.Component {

    render() {
        return (
            <section id="contactus" className="contact fullpage-section">
                <Row>
                    <Col xs="5" style={{paddingTop: '15vh'}}>
                        <h1 className='head'>CONTACT US</h1>
                        <img className='svgred3' src={require("./../../assets/img/Rectangle 4.svg")} />
                        <img className='line3' src={require("./../../assets/img/Rectangle 6.svg")} />
                         <br/>
                        <table className="contact-data">
                            <tr>
                                <td>Ravuri Siddartha</td>
                                <td>+91 8308303796</td>
                            </tr>
                            <tr>
                                <td>Nedheesh Hasija</td>
                                <td>+91 9811126777</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td>teamantriksh1@gmail.com</td>
                            </tr>
                        </table>
                    </Col>
                    <Col xs="7" id="contact-cover"><img className='cont' src={require("./../../assets/img/Image 9.png")} /></Col>
                    {/* <Col xs="7"><img src={require("./../../assets/img/logo.svg")} /></Col> */}
                </Row>
            </section>
        );
    }
}

export default Contact;
